<template>
    <center>
        <div
            :id="_uid + '_map'"
            :style="
                'width:100%;height: ' +
                height +
                '; background-color: #c5e8ff;padding:0px;margin:0px;'
            "
        ></div>
        <div v-show="false" ref="pop_up">
            {{ selected_index }}
        </div>
    </center>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

export default {
    props: {
        height: { type: String, default: '100vh' }
    },
    name: 'map-plot',
    data() {
        return {
            init_map: false,
            map: null,
            tileLayer: null,
            selected_index: -1
        }
    },
    computed: {
        locations() {
            return this.$store.state.locations
        },
        laguage() {
            return this.$i18n.locale
        }
    },
    watch: {
        locations() {
            this.updateMap()
        },
        $route() {
            this.updateMap()
        },
        laguage() {
            this.updateMap()
        }
    },
    mounted() {
        this.initMap()
    },
    methods: {
        initMap: function () {
            this.cameraIcon = L.icon({
                iconUrl: this.$store.state.publicPath + 'only_cam.png',
                iconSize: [60, 60], // size of the icon
                iconAnchor: [15, 15],
                popupAnchor: [-30, -30] // point from which the popup should open relative to the iconAnchor
            })
            this.cameraIconDisabled = L.icon({
                iconUrl: this.$store.state.publicPath + 'only_cam_disabled.png',
                iconSize: [60, 60], // size of the icon
                iconAnchor: [15, 15],
                popupAnchor: [-30, -30] // point from which the popup should open relative to the iconAnchor
            })

            var myOptions = {
                zoom: 8,
                center: [39.4, 2.7]
            }
            this.map = L.map(this._uid + '_map', myOptions)
            var osmLayer = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution:
                    '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
            })
            var bathymetryLayer = L.tileLayer.wms('https://ows.emodnet-bathymetry.eu/wms', {
                layers: 'emodnet:mean_atlas_land',
                format: 'image/png',
                transparent: true,
                attribution: 'Emodnet bathymetry',
                opacity: 0.8
            })
            var namesLayer = L.tileLayer.wms('https://ows.emodnet-bathymetry.eu/wms', {
                layers: 'world:sea_names',
                format: 'image/png',
                transparent: true,
                attribution: 'Emodnet bathymetry',
                opacity: 0.2
            })
            var underseaLayer = L.tileLayer.wms('https://ows.emodnet-bathymetry.eu/wms', {
                layers: 'gebco:undersea_features',
                format: 'image/png',
                transparent: true,
                attribution: 'Emodnet bathymetry',
                opacity: 0.2
            })
            var coastlinesLayer = L.tileLayer.wms('https://ows.emodnet-bathymetry.eu/wms', {
                layers: 'coastlines',
                format: 'image/png',
                transparent: true,
                attribution: 'Emodnet bathymetry',
                opacity: 0.8
            })

            var bathymetryGroupLayer = L.layerGroup([
                bathymetryLayer,
                coastlinesLayer,
                namesLayer,
                underseaLayer
            ])
            bathymetryGroupLayer.addTo(this.map)
            var baseMaps = {
                'Emodnet bathymetry': bathymetryGroupLayer,
                OSM: osmLayer
            }

            var layerControl = L.control.layers(baseMaps)
            layerControl.addTo(this.map)
            this.updateMap()
        },
        updateMap: function () {
            for (var index in this.locations) {
                var station = this.locations[index]
                var icon = this.cameraIcon
                if (!station.active) {
                    icon = this.cameraIconDisabled
                }
                var markerOptions = {
                    title: station.location_name,
                    icon: icon,
                    sation: station
                }
                var marker = L.marker([station.latitude, station.longitude], markerOptions)
                    .addTo(this.map)
                    .on(
                        'click',
                        function (event) {
                            this.selected_index = event.target.options.index
                        }.bind(this)
                    )

                let template =
                    '<div class="infocontent"><img src="' +
                    this.$store.state.publicPath +
                    'full_station.png" style="height:90px;float:left;" /><a href="#/filtering/?station=' +
                    station.location_code +
                    '"><h2>' +
                    station.location_name +
                    '</h2></a>'
                if (station.finish) {
                    template +=
                        "<p style='color:grey'>(" +
                        this.$t('from') +
                        ' ' +
                        station.deployment +
                        ' ' +
                        this.$t('until') +
                        ' ' +
                        station.finish +
                        ')</p>'
                } else {
                    template +=
                        '<p>(' +
                        this.$t('from') +
                        ' ' +
                        station.deployment +
                        ' ' +
                        this.$t('until now') +
                        ')</p>'
                }
                template += '<h4>' + this.$t('Camera groups') + '</h4>'
                template += "<table class='table table-stripped'>"
                template +=
                    '<tr><th>' +
                    this.$t('Code') +
                    '</th><th>' +
                    this.$t('Deployment') +
                    '</th><th>' +
                    this.$t('Last image') +
                    '</th></tr>'

                for (let index in station.camera_groups) {
                    const filteringURL = this.$router.resolve({
                        name: 'filtering',
                        query: {
                            station: station.location_code,
                            group: station.camera_groups[index].code
                        }
                    })
                    if (station.camera_groups[index].finish)
                        template +=
                            "<tr><td><a href='" +
                            filteringURL.href +
                            "'>" +
                            station.camera_groups[index].code +
                            '</a></td><td>' +
                            station.camera_groups[index].deployment +
                            '</td><td>' +
                            station.camera_groups[index].finish +
                            '</td></tr>'
                    else
                        template +=
                            "<tr><td><a href='" +
                            filteringURL.href +
                            "'>" +
                            station.camera_groups[index].code +
                            '</a></td><td>' +
                            station.camera_groups[index].deployment +
                            '</td><td>' +
                            this.$t('now') +
                            '</td></tr>'
                }
                template += '</th>'

                template += '</div>'
                marker.bindPopup(template)
            }
        }
    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
.popup,
.leaflet-popup-content {
    width: 400px !important;
}
.leaflet-popup-content h1 .title a {
    background-color: #1f8d98;
    color: white;
    font-size: 150%;
    padding: 10px;
}
.infocontent {
    background-color: white;
    color: #132b3f;
    font-size: 125%;
    padding: 20px;
}
.leaflet-popup-content-wrapper {
    background-color: #132b3f !important;
}
</style>
